module.exports = "<div class=\"wrapper\">\n  <img [src]=\"src\" alt=\"Design\">\n</div>\n"